import { render } from "./GenerosSelect.vue?vue&type=template&id=022eddfd"
import script from "./GenerosSelect.vue?vue&type=script&lang=js"
export * from "./GenerosSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__